import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { StoreUserBaseDto } from '@shared/StoreUser';
import { Observable } from 'rxjs';
import { AppConsts } from '@shared/app-consts';
import { AddressModel } from '@shared/AddressModel';
import { environment } from '@environment';
import { UpdatePhoneNumberRequest } from './security/update-phonenumber-request';
import { SecurityQuestionRequest } from '@shared/security/security-question-request.model';
import { UserConnectionFilterRequestModel } from '../shared/models/user/user-connection-request';

@Injectable()
export class AccountService extends BaseService {
  
  constructor(private http: HttpClient) {
    super();
  }

  GetAllByRoleName(roleName: string): Observable<StoreUserBaseDto[]> {

    let httpOptions = this.getHttpHeader();

    httpOptions.params = {
      roleName: roleName
    };

    return this.http.get(AppConsts.API_SERVICE_URL + "account/collaborators/allByRoleName", httpOptions) as Observable<StoreUserBaseDto[]>;
  }


  getMyAddress():Observable<AddressModel>{ 
   let httpOptions = this.getHttpHeader();  
   return this.http.get(AppConsts.API_SERVICE_URL + "salarie/GetConnectedUserAddress", httpOptions) as Observable<AddressModel>;
  }

  getPhoneNumber():Observable<any>{
    let httpOptions = this.getHttpHeader();  
   return this.http.get(AppConsts.API_SERVICE_URL + "account/GetConnectedUserPhoneNumber", httpOptions) as Observable<any>;
  }
  
  sendChangePhoneNumberTokenAsync(phoneNumber : string):Observable<any>{
    let httpOptions = this.getHttpHeader();  
    return this.http.post<string>(AppConsts.API_SERVICE_URL + "account/SendChangePhoneNumberTokenAsync", JSON.stringify(phoneNumber), httpOptions) as Observable<any>;
  }

  updatePhoneNumberAsync(request : UpdatePhoneNumberRequest):Observable<any>{
    let httpOptions = this.getHttpHeader();  
    return this.http.post<UpdatePhoneNumberRequest>(AppConsts.API_SERVICE_URL + "account/UpdatePhoneNumberAsync", request, httpOptions) as Observable<any>;
  }

  getTwoFactorEnabled():Observable<any>{
    let httpOptions = this.getHttpHeader();  
   return this.http.get(AppConsts.API_SERVICE_URL + "account/GetTwoFactorEnabledAsync", httpOptions) as Observable<any>;
  }

  setTwoFactorEnabledAsync(isEnabled : boolean):Observable<any>{
    let httpOptions = this.getHttpHeader();  
    return this.http.post<UpdatePhoneNumberRequest>(AppConsts.API_SERVICE_URL + "account/SetTwoFactorEnabledAsync", JSON.stringify(isEnabled), httpOptions) as Observable<any>;
  }

  getCoffreFortEnabled():Observable<any>{
    let httpOptions = this.getHttpHeader();  
    return this.http.post(AppConsts.API_SERVICE_URL + "Coffrefort/IsCoffrefortEnabled", httpOptions) as Observable<any>;
  }

  setCoffreFortEnabledAsync(isEnabled : boolean):Observable<any>{
    let httpOptions = this.getHttpHeader();  
    return this.http.post<any>(AppConsts.API_SERVICE_URL + "Coffrefort/EnableCoffrefort", JSON.stringify(isEnabled), httpOptions) as Observable<any>;
  }

  deleteMySecurityQuestionsAsync(id : number):Observable<any>{
    let httpOptions = this.getHttpHeader();  
    return this.http.post<any>(AppConsts.API_SERVICE_URL + "account/DeleteSecurityQuestion", id, httpOptions) as Observable<any>;
  }

  addMySecurityQuestionsAsync(request : SecurityQuestionRequest):Observable<any>{
    let httpOptions = this.getHttpHeader();  
    return this.http.post<any>(AppConsts.API_SERVICE_URL + "account/AddSecurityQuestion", request, httpOptions) as Observable<any>;
  }

  getMySecurityQuestionsAsync():Observable<any>{
    let httpOptions = this.getHttpHeader();  
    return this.http.post<any>(AppConsts.API_SERVICE_URL + "account/AllSecurityQuestion", null, httpOptions) as Observable<any>;
  }

  getSecurityQuestions(){
    let questions : any[]=[];
    questions.push( 
     {
     IdQuestion : 1,
     Question : "Quel était le nom de famille de votre professeur préféré ?"
    });
    questions.push( {
     IdQuestion : 2,
     Question : "Où êtes-vous allé lors de votre premier rendez-vous ?"
    });
    questions.push( {
     IdQuestion : 3,
     Question : "Quel était votre titre lors de votre premier emploi ?"
    });
    questions.push( {
     IdQuestion : 4,
     Question:"Quel était votre travail de rêve en tant qu'enfant ?"
    });
    questions.push( {
     IdQuestion : 5,
     Question :"Qui était votre héros d'enfance ?"
    });
    questions.push({
     IdQuestion : 6,
     Question:"Quel est votre personnage de dessin animé préféré ?"
    });
    questions.push({
     IdQuestion : 7,
     Question :"Quel est votre personnage historique préféré ?"
    });
    questions.push({
     IdQuestion: 8,
     Question:"Quel était votre livre / émission de télévision préféré quand vous étiez enfant ?"
    });
    questions.push({
     IdQuestion : 9,
     Question:"Quel est le nom de votre premier animal ?"
    });
    questions.push({
     IdQuestion : 10,
     Question:"Quel est ton film préféré ?"
    }); 

    return questions;
  }

  getuserconnections(request: UserConnectionFilterRequestModel): Observable<any> {
    let httpOptions = this.getHttpHeader();
    return this.http.post<UserConnectionFilterRequestModel>(AppConsts.API_SERVICE_URL + "account/getuserconnections", request, httpOptions) as Observable<any>;
  }

  updateEmail(newEmail: string) : Observable<boolean>{
    let httpOptions = this.getHttpHeader();
    return this.http.post<boolean>(AppConsts.API_SERVICE_URL + "account/updateEmail", JSON.stringify(newEmail), httpOptions);
  }

}
